var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.675,
    cy: 14.2434,
    rx: 14.675,
    ry: 14.2434,
    fill: "#6384E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3477 14.2434C24.3477 19.3842 20.0455 23.6023 14.675 23.6023C9.30457 23.6023 5.00229 19.3842 5.00229 14.2434C5.00229 9.10264 9.30457 4.88462 14.675 4.88462C20.0455 4.88462 24.3477 9.10264 24.3477 14.2434Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6935 34.5294L9.31793 25.4924L20.0692 25.4924L14.6935 34.5294Z",
    fill: "#6384E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8302 10.2494L18.6742 18.5294H17.1022L16.3822 16.4174H12.9742L12.3022 18.5294H10.8862L13.5622 10.2494H15.8302ZM13.3582 15.2294H15.9742L14.6302 11.2814L13.3582 15.2294Z",
    fill: "#6384E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMarker);
export default __webpack_public_path__ + "static/media/startMarker.1e18b2271678adfd879d5baaa021b516.svg";
export { ForwardRef as ReactComponent };